export default (clientHttp, apiVersion) => ({
  getClientPdf(id) {
    return clientHttp.upload(`${apiVersion}/user/contracts/client/${id}.pdf`)
  },
  getOwnerPdf(id) {
    return clientHttp.upload(`${apiVersion}/user/contracts/owner/${id}.pdf`)
  },
})
